const base = 8;
export default {
  standard:    base + 'px' ,
  small:       base/2 + 'px',
  large:       base*2 + 'px',
  xlarge:      base*3 + 'px',
  xxlarge:     base*4 + 'px'
}